import { Component, OnInit, QueryList, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { DataSource } from '@angular/cdk/table';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { APIIPRegisterService } from '../../_services/ip-register/API-ipregister';
import { Router,ActivatedRoute } from '@angular/router';


let now = new Date();
export interface gstnumbervalue {
  name: string
  value: string
}
@Component({
  selector: 'app-payment-dues',
  templateUrl: './payment-dues.component.html',
  styleUrls: ['./payment-dues.component.css']
})


export class PaymentDuesComponent implements OnInit {
  PaymentDuesForm: FormGroup;
  response: any
  dataSource: any;
  dataSubject = new BehaviorSubject<any[]>([]);
  displayedColumns: string[] = ['urn', 'item', 'amount', 'duedate', 'status', 'pay'];

  EntityID: any
  EntityName: any
  gstno: any
  pageNo: number = 1
  PaymentFlag: any;
  UrnFromURL: any; 
  loginFlag: any;
  gstnumber: gstnumbervalue[] = [
    { name: "GST1", value: "GST1" },
    { name: "GST2", value: "GST2" },
    { name: "GST3", value: "GST3" },

  ]
  @ViewChild('paginator') paginator: MatPaginator;

  constructor(private fb: FormBuilder,

    private db: $DBManagerService,
    private $modal: $ModalManagerService,
    private ip: APIIPRegisterService,
    private router: Router,
    private _route: ActivatedRoute
  ) { 
     //Added for Entity Payment
     this._route.params.subscribe((params) => {
			this.UrnFromURL = params['urn'];
		})
  }

  ngOnInit() {
    this.PaymentDuesForm = this.fb.group({
      urn: [''], 
      entityID: [''], //To allow from 15 to 19 digits
      entityName: [''],
      gst: [''],



    });

    this.loginFlag = this.db.get(Constants.SESSSION_STORAGE, Constants.LOGIN_FLAG);
    if(this.loginFlag){
    this.EntityID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
    this.EntityName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME)
    let Flag = this.db.get(Constants.SESSSION_STORAGE, Constants.PAYMENT_FLAG)
    this.PaymentFlag = atob(Flag)
    if(this.PaymentFlag == "true"){
      let EntityRefNo= this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN)
      this.PaymentDuesForm.controls['urn'].setValue(EntityRefNo);
    }
    this.PaymentDuesForm.controls['entityID'].setValue(this.EntityID);
    this.PaymentDuesForm.controls['entityName'].setValue(this.EntityName);
    this.getPaymentDuesDetails();
    }
    else{
      this.getEntityDetails();
    }
  }
  setGstno(event) {
    console.log("event", event)
    this.gstno = event.target.value
  }

  get f() { return this.PaymentDuesForm.controls; }

  async onSubmit() {
    if (this.PaymentDuesForm.invalid) {
      return;
    }
    else {

      var data = {
        EntityID: this.PaymentDuesForm.get("entityID").value,
        Entity_Name: this.PaymentDuesForm.get("entityName").value,
        Created_By: this.PaymentDuesForm.get("entityID").value
      }
      await this.ip.addNewIP(data)
        .subscribe(r => {
          console.log("response is : ", r)


        })
      // this.getListIPAddress()


    }

  }

  getEntityDetails(){
    if(this.UrnFromURL == undefined || this.UrnFromURL == "undefined"){
      this.UrnFromURL = this.db.get(Constants.SESSSION_STORAGE, Constants.PAYMENTFORURN);
    }
    this.ip.getEntityDetails(this.UrnFromURL)
    .subscribe((response)=>{
      this.PaymentFlag = "true"
     
      this.PaymentDuesForm.controls['urn'].setValue(response.Entity_Ref_No);
      this.PaymentDuesForm.controls['entityName'].setValue(response.E_Org_Name);
      this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, response.Entity_ID);
      this.db.set(Constants.SESSSION_STORAGE, Constants.ORG_NAME, response.E_Org_Name);  
	  this.db.set(Constants.SESSSION_STORAGE, Constants.PAYMENT_FLAG,btoa("true"));	  
      this.EntityID = response.Entity_ID
      this.getPaymentDuesDetails();  
      
    })
  }

  getPaymentDuesDetails() {

    //this.ip.getPaymentInfo(this.EntityID ? this.EntityID : "NA", this.paginator.pageIndex ?  this.paginator.pageIndex+1 : "1", this.paginator.pageSize ?  this.paginator.pageSize : "5")
    this.ip.getPaymentInfo(this.EntityID ? this.EntityID : "NA", "1", "10000")
      .subscribe((response) => {
        this.dataSource = new MatTableDataSource(response);
        this.dataSource.paginator = this.paginator;
      });
    // .subscribe(
    //   {
    //   next: response => {
    //     this.dataSubject.next(response);
    //     this.dataSource = new MatTableDataSource();

    //     this.dataSource = new MatTableDataSource(response);
    //     this.dataSource.paginator = this.paginator;
    //     // this.dataSource.sort = this.sort;
    //   }
    // });

  }

  Next() {
    this.pageNo = this.pageNo + 1
    this.getPaymentDuesDetails()
  }

  Previous() {
    this.pageNo = this.pageNo - 1
    this.getPaymentDuesDetails()
  }


  downloadPaymentDuescsvfile() {
    var data = {

    }
    if (this.EntityID)
      data["EntityID"] = this.EntityID

    var fileName;
    const currentdate = formatDate(now, 'medium', 'en-US', '+0530');
    this.ip.exportpaymentDuesCSV(data).subscribe(r => {
      fileName = currentdate + "_" + this.EntityID + '_Dues.csv';
      importedSaveAs(r, fileName)
      this.$modal.successModal({
        title: 'Payment Dues',
        msg: 'File has been downloaded Successfully'
      });
    })


  }

  paynow(urn, amount,description) {
    this.db.set(Constants.SESSSION_STORAGE, Constants.PAYMENTFORURN, urn);
    this.db.set(Constants.SESSSION_STORAGE, Constants.TRANSACTIONAMOUNT, amount);
    this.db.set(Constants.SESSSION_STORAGE, Constants.MODULEFORPAYMENT, description);

    this.router.navigate(['payment-submit'])
    //this.router.navigate(['payment-submit'], { queryParams: { urn: urn,entityID:this.EntityID,entityName:this.EntityName } });

  }

}




